import React from 'react';

const data = [
  {
    year: '0 month',
    content: 'more than 3 videos',
    detail: '140-200$'
  },
    {
    year: '1 month',
    content: 'more than 6 videos',
    detail: '280-400$'
  },
    {
    year: '2 month',
    content: 'more than 9 videos',
    detail: '525-800$'
  },
    {
    year: '3 month',
    content: 'more than 10 videos',
    detail: '875-1500$'
  },
    {
    year: '4 month',
    content: 'more than 10 videos',
    detail: '1500-3500$'
  },
    {
    year: '5 month',
    content: 'more than 10 videos',
    detail: 'more than 6000$'
  },

]

export default () => (
  <section className='container-fluid pt-0' id='listcomplish'>
          <div className='linebg'>
            <img
                src="./img/linebg.png"
                className="img-fluid"
                alt="Imageteam"
              />
          </div>
          <div className='row m-2-hor'>
            <div className='col-12 mb-5' style={{marginTop: 15}}>
              <div className='heading'>How much can you earn</div>
            </div>
            <div className='col-12'>
              {data.map( (d, index) => (
                  <div className='listcomplish' key={index}>
                    <span className='year'>{d.year}</span>
                    <span className='content'>{d.content}</span>
                    <span className='detail'>{d.detail}</span>
                  </div>
              ))}

              {/*<div className='listcomplish'>*/}
              {/*  <span className='year'>2020</span>*/}
              {/*  <span className='content'>Nature Bliss Straight Modular Kitchen</span>*/}
              {/*  <span className='detail'>Kitchen Home</span>*/}
              {/*</div>*/}
              {/*<div className='listcomplish'>*/}
              {/*  <span className='year'>2019</span>*/}
              {/*  <span className='content'>Woody Mist Straight Wardrobe Designs</span>*/}
              {/*  <span className='detail'>Wardrobe Designs</span>*/}
              {/*</div>*/}
              {/*<div className='listcomplish'>*/}
              {/*  <span className='year'>2019</span>*/}
              {/*  <span className='content'>Contemporary Entertainment Wall Units</span>*/}
              {/*  <span className='detail'>Entertainment</span>*/}
              {/*</div>*/}
              {/*<div className='listcomplish'>*/}
              {/*  <span className='year'>2018</span>*/}
              {/*  <span className='content'>Space Saving Furniture Palermo</span>*/}
              {/*  <span className='detail'>Modern Furniture</span>*/}
              {/*</div>*/}
              {/*<div className='listcomplish'>*/}
              {/*  <span className='year'>2018</span>*/}
              {/*  <span className='content'>Eclectic Theme Interiors For Living Room</span>*/}
              {/*  <span className='detail'>Modern Interiors</span>*/}
              {/*</div>*/}
              {/*<div className='listcomplish'>*/}
              {/*  <span className='year'>2018</span>*/}
              {/*  <span className='content'>Pop Theme Home Interiors</span>*/}
              {/*  <span className='detail'>Home Interiors</span>*/}
              {/*</div>*/}
              {/*<div className='listcomplish'>*/}
              {/*  <span className='year'>2017</span>*/}
              {/*  <span className='content'>Kid Friendly Theme Home Interiors</span>*/}
              {/*  <span className='detail'>Kid Modern Interiors</span>*/}
              {/*</div>*/}

            </div>
          </div>
        </section>
);
